<template>
  <v-container>
    <v-row class="justify-center mt-1">
      <v-col>
        <h2 class="mentors-headline primary--text text-center">מנטורים IL</h2>
      </v-col>
    </v-row>
    <v-row
      class="mentors-text display-24 justify-center secondary2--text text-center mb-5"
    >
      ריכזנו עבורכם מגוון סרטוני הדרכה של
      <br v-if="this.$vuetify.breakpoint.xsOnly" />
      המומחים שלנו בנושאים
      <br v-if="this.$vuetify.breakpoint.smAndUp" />
      הכי חמים של
      <br v-if="this.$vuetify.breakpoint.xsOnly" />
      עולם העבודה
    </v-row>
    <MentorsArticle />

    <v-row class="text-center mt-8">
      <v-col>
        <nuxt-link :to="'/articles/cat10/'">
          <v-btn rounded color="primary" class="btn-all">
            לכל סרטוני ההדרכה
          </v-btn>
        </nuxt-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MentorsArticle from '@/components/HomePageComponents/MentorsArticle';
export default {
  components: {
    MentorsArticle,
  },
};
</script>

<style lang="scss" scoped>
.mentors-text {
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -0.025em;
  text-align: center;
}
.btn-all {
  width: 207px;
  &:hover {
    background-color: #3e4a54 !important;
  }
}
.mentors-headline {
  font-size: 56px;
  font-weight: 400;
  line-height: 66px;
  letter-spacing: -0.025em;
  text-align: center;
}
@media only screen and (max-width: 600px) {
  .mentors-text {
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.025em;
    text-align: center;
  }
  .mentors-headline {
    font-size: 33px;
    font-weight: 400;
    line-height: 39px;
    letter-spacing: -0.025em;
    text-align: right;
  }
  .btn-all {
    width: 193px;
  }
}
</style>